export default {
  audit: {
    alocationSituation: 'Situação Alocação',
    sendSituation: 'Situação Envio',
    alocation: 'Alocação',
    stores: 'Lojas',
    auditHistory: 'Histórico de Alocação',
    productCode: 'Código do Produto',
    skuCode: 'Código SKU',
    sizeCode: 'Código Tamanhho',
    storeOrders: 'Pedidos Loja',
    quantityAlocated: 'Quantidade alocada',
    quantityMissing: 'Quantidade faltante',
    quantityDemanded: 'Quantidade pedida',
    color: 'Sortimento',
    productName: 'Nome do Produto',
    storeCode: 'Código Loja',
    totalPieces: 'Total de Peças',
    message: 'Mensagem',
    information: 'Informação',
    emissionDate: 'Data de Emissão',
    integrationDate: 'Data da Integração',
    store: 'Loja',
    order: 'Pedido',
    notIntegrated: 'Pedido não integrado ao ERP',
  },
  estoqueCentral: {
    title: 'Consulta de estoque de lojas',
    description: 'Esta ferramenta permite consultar o estoque disponível em todas as lojas da rede Tata Martello. Navegue pelos produtos, selecione cores e tamanhos para visualizar a disponibilidade em tempo real. Os estoques são atualizados automaticamente a cada acesso para garantir informações precisas.',
    tableTitle: 'Produtos em Estoque',
    searchPlaceholder: 'Buscar por nome ou código da referência...',
    verCores: 'Ver Cores',
    errorLoading: 'Erro ao carregar dados do estoque central',
    noDataAvailable: 'Nenhum produto encontrado',
    pagination: {
      itemsPerPage: 'Itens por página',
      showingRecords: 'Mostrando {start}-{end} de {total} registros',
      noResults: 'Nenhum resultado encontrado',
      page: 'Página {current} de {total}',
      goToFirst: 'Primeira página',
      goToPrevious: 'Página anterior',
      goToNext: 'Próxima página',
      goToLast: 'Última página',
    },
    fields: {
      nomeReferencia: 'Nome da Referência',
      codigoReferencia: 'Código da Referência',
      categoria: 'Categoria',
      marca: 'Marca',
      acoes: 'Ações',
      codigo: 'Código',
      produto: 'Produto',
      quantidade: 'Quantidade',
      preco: 'Preço',
      status: 'Status',
    },
  },
};
